/* eslint-disable import/prefer-default-export */
import type { Pair } from './types';

export const createEmptyPair: () => Pair = () => ({ key: '', value: '' });
